import { styled } from '@mui/material';

import { colors } from '../../../../theme';

export const Attachment = styled('div')<{ trim: boolean }>(({ trim }) => ({
    display: 'inline-flex',
    alignItems: 'center',
    verticalAlign: 'middle',
    gap: '5px',
    backgroundColor: '#20222D',
    paddingTop: '10px',
    fontSize: '12px',
    borderRadius: '15px',
    ...(trim && {
        maxWidth: '200px'
    }),

    svg: {
        width: '12px',
        height: '12px'
    },

    span: {
        color: colors.yellow,
        flexGrow: 1,
        wordBreak: 'break-all',
        ...(trim
            ? {
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
            }
            : {
                whiteSpace: 'normal',
                wordBreak: 'break-word'
            })
    }
}));

export const RemoveAttachmentContainer = styled('div')({
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    padding: '2px'
});
